import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	descriptionContainer: {
		width: '100%',
		marginBottom: theme.spacing.medium,
	},

	description: {
		marginBottom: theme.spacing.tiny,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		display: '-webkit-box',
		/** BodyMd height + line height * amount of lines to show */
		maxHeight: `calc(${theme.fontSize.large} * 3)`,
		lineClamp: 3,
		WebkitLineClamp: 3,
		WebkitBoxOrient: 'vertical',
	},
	readMoreButton: {
		font: theme.typography.bodyMd,
	},
}));
